import React, { useMemo, useRef } from 'react';
import { useEffect } from 'react';
import echarts from 'echarts';
import { processChartData } from '@/utils/device';
import getChartOptions from '@/utils/chartOptions';
import { YAXIS_INFO, EMPTY_MINITOR } from '../config';
import styles from '../index.less';

const MonitorChart = ({ type, isError, dataCurves, isOffline }) => {
  const chartDomID = `${type}-chart`;
  const indicatorRef = useRef(chartDomID);
  const chartInfo = useMemo(() => YAXIS_INFO[type] || {}, [type]);

  useEffect(() => {
    if (isOffline || isError) return;
    const processData = dataCurves?.length > 0 ? processChartData(dataCurves, type) : EMPTY_MINITOR;
    const chartData = {
      xData: processData.xData,
      yData: processData.yData,
      yTitle: YAXIS_INFO[type].title,
    };
    const chartOptions = getChartOptions(type, chartData);
    const indicatorChart = echarts.init(indicatorRef.current);
    indicatorChart.setOption(chartOptions);
    return () => echarts.dispose(indicatorChart);
  }, [dataCurves, type, isOffline, isError]);

  return (
    <div>
      <span className={styles['chart-standard']}>{chartInfo.standard}</span>
      <div className={styles['indicator-body']}>
        {type === 'online' && (
          <div className={styles['chart-title']}>
            <span>普通收益</span>
            <span>高收益</span>
          </div>
        )}
        <div className={styles['chart-wrapper']}>
          <div className={styles['chart']} id={chartDomID} ref={indicatorRef}></div>
          {(isError || isOffline) && (
            <div className={styles['error-box']}>
              <img src={require('@/assets/images/monitor/noData.png')} alt="error" />
              <p>{isOffline ? '设备离线，暂无数据' : '系统繁忙，稍后再试吧'}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default MonitorChart;
